import React, { useState, useEffect } from "react";
import "./ClearGlass.css";
import Header from '../../Header/Header';
import Footer from '../../Footer/Footer';
import WindowGlassBanner from "../../../Assets/Product_Images/WindowGlass/window-banner.jpg";
import { Link } from "react-router-dom";
import clear_glass from "../../../Assets/Product_Page/clear_glass.webp";
import features_img from "../../../Assets/Product_Page/features_img.webp";
import applications from "../../../Assets/Product_Page/applications.webp";
import features_1 from "../../../Assets/Product_Page/features_1.webp";
import features_2 from "../../../Assets/Product_Page/features_2.webp";
import features_3 from "../../../Assets/Product_Page/features_3.webp";
import applications_1 from "../../../Assets/Product_Page/applications_1.webp";
import applications_2 from "../../../Assets/Product_Page/applications_2.webp";
import applications_3 from "../../../Assets/Product_Page/applications_3.webp";
import applications_4 from "../../../Assets/Product_Page/applications_4.webp";
import applications_5 from "../../../Assets/Product_Page/applications_5.webp";
import api, { PUBLIC_BASE_URL } from "../../../api/api";

const WindowGlass = () => {

    const [activeTab, setActiveTab] = useState('features');
  const featureImages = [features_1, features_2, features_3]; // Add more images as needed
  const applicationImages = [applications_1, applications_2, applications_3, applications_4, applications_5]; // Add more images as needed

  const [clearGlassData, setClearGlassData] = useState([]);

  useEffect(() => {
    api.get("/clear-glass") // Make sure the route is correct
      .then((res) => {
        console.log(res.data);
        setClearGlassData(res.data);
      })
      .catch((err) => {
        console.error("Error fetching Clear Glass data", err);
      });
  }, []);

  const imageUrl =
  clearGlassData.length > 0
    ? `${PUBLIC_BASE_URL}/storage/${clearGlassData[0].image}`
    : "";


  const title = clearGlassData.length > 0 ? clearGlassData[0].title : 'ClearGlass';

  return (
    <div>
      <Header />

      {/* Banner section */}
      <section className="container-fluid common_banner"
        style={{
          backgroundImage: `url(${WindowGlassBanner})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="common_title wow fadeInUp">
                <h1>
                  <Link to='/Product' className="text-decoration-none text-white">
                    PRODUCTS / {title}
                  </Link>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Product section */}
      <section className="container-fluid clear_sction">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="clear_text">
                {/* Assuming clear_glass is an image */}
                <img src={imageUrl} alt="Clear Glass" />



                <h5>{title}</h5>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Tabs section */}
<section className="container-fluid features_section">
  <div className="container">
    <div className="row">
      <div className="col-lg-12 col-md-12 col-sm-12">
        <div className="tabs">
          <div className="tab-buttons">
            <button
              className={`tab-btn ${activeTab === 'features' ? 'active' : ''}`}
              onClick={() => setActiveTab('features')}
            >
              Features
            </button>
            <button
              className={`tab-btn ${activeTab === 'applications' ? 'active' : ''}`}
              onClick={() => setActiveTab('applications')}
            >
              Applications
            </button>
          </div>

          {/* Features Tab */}
          {activeTab === 'features' && (
            <div id="features" className="tab-content active">
              <ul>
                {clearGlassData.map((item, index) => (
                  // Check if features is an array or a string
                  (Array.isArray(item.features) ? item.features : JSON.parse(item.features || "[]"))
                    .map((feature, i) => (
                      <li key={i}>
                        {/* Dynamically select image based on index */}
                        <img
                          src={featureImages[i % featureImages.length]} // Use modulus for looping over images if there are more features than images
                          alt={`Feature ${i + 1}`}
                        />
                        {feature}
                      </li>
                    ))
                ))}
              </ul>
            </div>
          )}

          {/* Applications Tab */}
          {activeTab === 'applications' && (
            <div id="applications" className="tab-content active">
              <ul>
                {clearGlassData.map((item, index) => (
                  // Check if applications is an array or a string
                  (Array.isArray(item.applications) ? item.applications : JSON.parse(item.applications || "[]"))
                    .map((application, i) => (
                      <li key={i}>
                        {/* Dynamically select image based on index */}
                        <img
                          src={applicationImages[i % applicationImages.length]} // Use modulus for looping over images if there are more applications than images
                          alt={`Application ${i + 1}`}
                        />
                        {application}
                      </li>
                    ))
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  </div>
</section>




      <Footer />
    </div>
  )
}

export default WindowGlass
